const badRequest = 400;
const notFound = 404;
const conflict = 409;
const serverError = 500;

export { badRequest, notFound, conflict, serverError };
